import React from 'react'

interface LogoProps {
  src: string
  alt: string
  width: number
  height: number
}

export const Logo: React.FC<LogoProps> = ({
  src,
  alt,
  width,
  height
}) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className='w-[120px] h-[50px] md:w-[200px] md:h-[80px]'
    />
  )
}
